import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Accordion from "react-bootstrap/Accordion";
import CloseButton from "react-bootstrap/CloseButton";
import { useFieldArray } from "react-hook-form";
import _ from "lodash";

import SecondaryButton from "../SecondaryButton";
import FormField from "./FormField";

const FormFieldArray = ({ field, form }) => {
  const {
    fields: groupedFields,
    append,
    remove,
  } = useFieldArray({
    control: form.control,
    name: field.name,
  });

  return (
    <Container>
      <Accordion alwaysOpen>
        {groupedFields.map((item, index) => (
          <Accordion.Item key={item} eventKey={index} style={{ marginBottom: '10px' }}>
            <Accordion.Header>
              {field.arrayLabel} {index + 1}{" "}
              <CloseButton onClick={() => remove(index)} />
            </Accordion.Header>
            <Accordion.Body>
              {field.fields.map((i) => {
                return (
                  <Container key={`${field.name}-${i.name}`}>
                    <FormField
                      field={{ ...i, name: `${field.name}.${index}.${i.name}` }}
                      form={form}
                    />
                    {_.get(
                      form.formState.errors,
                      `${field.name}.${index}.${i.name}`
                    ) && (
                      <p className="text-danger">
                        {
                          _.get(
                            form.formState.errors,
                            `${field.name}.${index}.${i.name}`
                          ).message
                        }
                      </p>
                    )}
                  </Container>
                );
              })}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      <Container style={{ marginTop: '13px' }}>
        <Row>
          <SecondaryButton
            disabled={field?.disabled}
            onClick={() => {
              append(
                field.fields.reduce((acc, i) => {
                  acc[i.name] = null;
                  return acc;
                }, {})
              );
            }}
          >
            {field.arrayLabel}
          </SecondaryButton>
        </Row>
        {_.get(form.formState.errors, `${field.name}`) && (
          <p className="text-danger">
            {_.get(form.formState.errors, `${field.name}`).message}
          </p>
        )}
      </Container>
    </Container>
  );
};

export default FormFieldArray;
